import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import {DATE_PIPE_DEFAULT_OPTIONS} from '@angular/common';
import {provideRouter} from '@angular/router';
import {provideHttpClient, withInterceptors} from '@angular/common/http';

import {routes} from './app.routes';
import {authExpiryInterceptor} from './auth-session.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authExpiryInterceptor])),
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { timezone: 'Pacific/Auckland' } },
  ],
};
